import React, { useMemo } from 'react';
import classNames from 'classnames';
import {
  useTable,
  useSortBy,
  useFilters,
  useGlobalFilter,
  usePagination,
} from 'react-table';

import BaseTable from '../../../shared/BaseTable';
import Loading from '../../../shared/Loading';
import { TableColumns } from './TableColumns';

export default function PSTable({ payment_schedule, err }) {
  const data = useMemo(() => payment_schedule, [payment_schedule]);
  const columns = useMemo(() => TableColumns, []);
  const sortTypes = React.useMemo(
    () => ({
      alphanumericFalsyLast(rowA, rowB, columnId) {
        const a = Number(rowA.values[columnId]);
        const b = Number(rowB.values[columnId]);

        return Number(a) - Number(b);
      },
    }),
    [],
  );
  const instance = useTable(
    {
      columns,
      data,
      initialState: {
        pageSize: 5,
        sortBy: [{ id: 'due_date', desc: true }],
      },
      sortTypes,
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
  );

  if (!payment_schedule) return <Loading className="w-14 h-14" />;

  return (
    <div
      role={PSTable.role}
      className="col-span-full rounded-lg border border-black border-opacity-5 py-1 overflow-x-scroll mt-6"
    >
      <div className="text-xl font-avenir-black text-navy-blue px-6 py-3 border-b">
        Payment Schedule
      </div>
      <BaseTable
        tableInstance={instance}
        noDataFoundWarning={
          err
            ? 'Error: Unable to retrieve payment schedule.'
            : 'No payment schedule found.'
        }
        tableClass="min-h-[21rem]"
        addRows={6}
        fillTable={true}
      />
    </div>
  );
}

PSTable.role = 'payment-schedule-table-component';
